import Vue from 'vue'
import Router from 'vue-router'
import { routeConfig } from '@/configs/config'

import Index from '@/pages/index'
import Product from '@/pages/product'
import Product1 from '@/pages/product/product1'
import Product2 from '@/pages/product/product2'
import Product3 from '@/pages/product/Product3'
import Product4 from '@/pages/product/Product4'
import Product5 from '@/pages/product/Product5'
import Application from '@/pages/application'
import Application1 from '@/pages/application/application1'
import Application2 from '@/pages/application/application2'
import Application3 from '@/pages/application/application3'
import Application4 from '@/pages/application/application4'
import Application5 from '@/pages/application/application5'
import Application6 from '@/pages/application/application6'
import Application7 from '@/pages/application/application7'
import Application8 from '@/pages/application/application8'
import Application9 from '@/pages/application/application9'
import Application10 from '@/pages/application/application10'
import Application11 from '@/pages/application/application11'
import Application12 from '@/pages/application/application12'
import Application13 from '@/pages/application/application13'
import Application14 from '@/pages/application/application14'
import Application15 from '@/pages/application/application15'
import Case from '@/pages/case'
import CaseVideo from '@/pages/caseVideo'
import Service from '@/pages/service'
import News from '@/pages/news'
import Newsdetails from '@/pages/news/newsdetails'
import Development from '@/pages/development'
import About from '@/pages/about'
import Process from '@/pages/process'
import Digital from '@/pages/digital'
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

export default new Router({
  base: routeConfig.base,
  mode: routeConfig.mode,
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/product',
      name: 'Product',
      component: Product
    },
    {
      path: '/product/product1',
      name: 'Product1',
      component: Product1
    },
    {
      path: '/product/product2',
      name: 'Product2',
      component: Product2
    }, {
      path: '/product/product3',
      name: 'Product3',
      component: Product3
    }, {
      path: '/product/product4',
      name: 'Product4',
      component: Product4
    }, {
      path: '/product/product5',
      name: 'Product5',
      component: Product5
    },
    {
      path: '/application',
      name: 'Application',
      component: Application
    },
    {
      path: '/application/application1',
      name: 'Application1',
      component: Application1
    },
    {
      path: '/application/application2',
      name: 'Application2',
      component: Application2
    }, {
      path: '/application/application3',
      name: 'Application3',
      component: Application3
    }, {
      path: '/application/application4',
      name: 'Application4',
      component: Application4
    }, {
      path: '/application/application5',
      name: 'Application5',
      component: Application5
    }, {
      path: '/application/application6',
      name: 'Application6',
      component: Application6
    }, {
      path: '/application/application7',
      name: 'Application7',
      component: Application7
    }, {
      path: '/application/application8',
      name: 'Application8',
      component: Application8
    }, {
      path: '/application/application9',
      name: 'Application9',
      component: Application9
    }, {
      path: '/application/application10',
      name: 'Application10',
      component: Application10
    }, {
      path: '/application/application11',
      name: 'Application11',
      component: Application11
    }, {
      path: '/application/application12',
      name: 'Application12',
      component: Application12
    }, {
      path: '/application/application13',
      name: 'Application13',
      component: Application13
    }, {
      path: '/application/application14',
      name: 'Application14',
      component: Application14
    }, {
      path: '/application/application15',
      name: 'Application15',
      component: Application15
    },
    {
      path: '/case',
      name: 'Case',
      component: Case
    },
    {
      path: '/caseVideo',
      name: 'caseVideo',
      component: CaseVideo
    },
    {
      path: '/service',
      name: 'Service',
      component: Service
    },
    {
      path: '/news',
      name: 'News',
      component: News
    }, {
      path: '/news/:id',
      name: 'Newsdetails',
      component: Newsdetails
    },
    {
      path: '/development',
      name: 'Development',
      component: Development
    },
    {
      path: '/digital',
      name: 'Digital',
      component: Digital
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/process',
      name: 'Process',
      component: Process
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js